// API client for the Vendor ACH Payment module (Pay ACH Invoices modal).
// All endpoints accept an optional `accountId` — used by super-admins to
// scope the request to a specific org (matches the existing pattern used
// across PaymentsDashboard / LateFeeReport / etc.).
import api from '../lib/api';
import { getCurrentAccount } from '../lib/auth';

const _aid = (accountId) =>
  accountId || getCurrentAccount()?.id || undefined;

const _params = (accountId) => {
  const id = _aid(accountId);
  return id ? { account_id: id } : {};
};

export const fetchVendorAchPreview = (paymentFileId, accountId) =>
  api
    .get(`/payment-files/${paymentFileId}/vendor-ach-preview`, {
      params: _params(accountId),
    })
    .then((r) => r.data);

export const listVendorAchSetup = (accountId) =>
  api.get('/vendor-ach/setup', { params: _params(accountId) }).then((r) => r.data);

export const upsertVendorAchSetup = (payload, accountId) =>
  api
    .put('/vendor-ach/setup', payload, { params: _params(accountId) })
    .then((r) => r.data);

export const deleteVendorAchSetup = (supplierId, accountId) =>
  api.delete(`/vendor-ach/setup/${encodeURIComponent(supplierId)}`, {
    params: _params(accountId),
  });

export const draftCtxNacha = ({ paymentFileId, supplierIds, accountId, ach_format = 'CTX', bank_code = 'ABS' }) =>
  api.post(
    '/vendor-ach/draft-nacha',
    {
      payment_file_id: paymentFileId,
      supplier_ids: supplierIds || [],
      ach_format,
      bank_code,
    },
    { responseType: 'blob', params: _params(accountId) },
  );

export const payVendorAch = ({ paymentFileId, supplierIds, accountId, ach_format = 'CTX', bank_code = 'ABS' }) =>
  api
    .post(
      '/vendor-ach/pay',
      {
        payment_file_id: paymentFileId,
        supplier_ids: supplierIds || [],
        ach_format,
        bank_code,
      },
      { params: _params(accountId) },
    )
    .then((r) => r.data);

export const listVendorAchBatches = (paymentFileId, accountId) =>
  api
    .get('/vendor-ach/batches', {
      params: {
        ..._params(accountId),
        ...(paymentFileId ? { payment_file_id: paymentFileId } : {}),
      },
    })
    .then((r) => r.data);

export const retransmitVendorAchBatch = (batchId, accountId) =>
  api
    .post(`/vendor-ach/batches/${encodeURIComponent(batchId)}/transmit`, {}, {
      params: _params(accountId),
    })
    .then((r) => r.data);

// Download a per-vendor NACHA file persisted on a committed batch (CTX flow).
// Used by the Pay ACH Invoices modal's NACHA File column post-Pay.
export const downloadVendorBatchFile = (batchId, supplierId, accountId) =>
  api.get(
    `/vendor-ach/batches/${encodeURIComponent(batchId)}/vendor-files/${encodeURIComponent(supplierId)}/download`,
    { responseType: 'blob', params: _params(accountId) },
  );
